(() => {
  const rules = {
    'langhaarmadchen-haarol-intense-repair-150-ml': {kind:'hair-oil', goals:['dry-ends','frizz'], skinTypes:[], fragranceFree:false, active:false, usage:'Work a small amount through damp or dry lengths and ends, following the bottle directions. Do not apply as scalp care.', reason:'A finishing oil for dry lengths and flyaways.'},
    'balea-professional-haarol-oil-repair-intensiv-100-ml': {kind:'hair-oil', goals:['dry-ends','frizz'], skinTypes:[], fragranceFree:false, active:false, usage:'Use sparingly through lengths and ends before washing or on towel-dried hair. Follow the bottle directions.', reason:'A lower-priced finishing oil for dry lengths.'},
    'balea-gesichtsserum-beauty-hyaluron-7-fach-30-ml': {kind:'serum', goals:['hydration'], skinTypes:['normal','dry','oily','combination'], fragranceFree:false, active:false, usage:'Apply 2-3 drops after cleansing, before moisturiser, morning or evening. Check the packaging directions.', reason:'A hyaluronic-acid serum selected for your hydration goal.'},
    'balea-serum-niacinamide-30-ml': {kind:'serum', goals:['shine','blemishes'], skinTypes:['oily','combination'], fragranceFree:true, active:true, usage:'Apply 2-3 drops after cleansing, morning or evening as needed. Avoid the eye area. Follow the packaging directions.', reason:'A fragrance-free niacinamide serum formulated for oily and combination skin.'},
    'balea-anti-pickel-waschgel-hautrein-150-ml': {kind:'cleanser', goals:['blemishes'], skinTypes:['oily','combination'], fragranceFree:false, active:true, usage:'Massage onto damp skin, then rinse thoroughly. Avoid the eye area and follow the packaging directions.', reason:'A rinse-off cleanser with salicylic acid for blemish-prone skin.'},
    'balea-anti-pickel-24h-pflege-hautrein-50-ml': {kind:'moisturizer', goals:['blemishes'], skinTypes:['oily','combination'], fragranceFree:true, active:true, usage:'Apply after cleansing, avoiding the eye area. Follow the packaging directions.', reason:'A fragrance-free moisturiser with salicylic acid for blemish-prone skin.'},
    'sundance-sonnencreme-lsf-50-100-ml': {kind:'spf', goals:['hydration','shine','blemishes'], skinTypes:['normal'], fragranceFree:false, active:false, usage:'Apply generously before sun exposure and reapply as directed, especially after swimming, sweating or drying. Sunscreen does not provide complete UV protection.', reason:'An SPF 50 sunscreen for normal skin, used as the final morning skincare step.'}
  };
  const choiceNames = {'hair-oil': 'Hair oil', serum: 'Serum', cleanser: 'Cleanser', moisturizer: 'Moisturiser', spf: 'Sunscreen'};
  function element(tag, text, className) {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  }
  async function jsonRequest(url, options = {}) {
    const response = await fetch(url, {...options, signal: AbortSignal.timeout(15000), headers: {'Accept':'application/json', ...options.headers}});
    if (!response.ok) {
      const error = new Error('The shop could not complete this request. Please try again.');
      error.status = response.status;
      throw error;
    }
    const data = await response.json();
    return data;
  }
  class DodoRoutine extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.pending = false;
      this.step = 0;
      this.root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
      this.form = this.querySelector('form');
      this.status = this.querySelector('.dr__status');
      this.results = this.querySelector('.dr__results');
      this.catalog = JSON.parse(this.querySelector('[data-catalog]').textContent).filter(p => rules[p.handle]).map(p => ({...p,...rules[p.handle]}));
      if (!window.DodoRoutineEngine) { this.status.textContent = 'The routine builder could not load. Please reload this page or contact us.'; return; }
      if (this.dataset.currency !== 'AED') { this.status.textContent = 'The routine builder currently uses AED pricing. Choose the UAE market to build a routine, or contact us for help.'; return; }
      this.form.hidden = false;
      this.form.addEventListener('change', () => this.areaChanged());
      this.querySelector('[data-back]').addEventListener('click', () => this.showStep(this.step - 1));
      this.querySelector('[data-edit]').addEventListener('click', () => { if (this.pending) return; this.results.hidden = true; this.form.hidden = false; this.status.textContent = ''; this.showStep(0); });
      this.querySelector('[data-add]').addEventListener('click', () => this.addToCart());
      this.querySelector('[data-save]')?.addEventListener('click', () => this.saveRoutine());
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.started) { this.started = true; this.track('routine_started'); }
        if (this.step < 2) { this.track('routine_step_completed', {step:this.step + 1}); this.showStep(this.step + 1); }
        else this.build();
      });
      this.onPageHide = () => { if (this.started && !this.cartAdded) this.track('routine_left', {step:this.step + 1}); };
      window.addEventListener?.('pagehide', this.onPageHide);
      const initial = new URLSearchParams(location.search);
      const area = initial.get('area');
      if (area === 'hair') this.form.elements.area.value = 'hair';
      const goal = initial.get('goal');
      const goalInput = this.form.elements[area === 'hair' ? 'hairGoal' : 'skinGoal'];
      if ([...goalInput.options].some(o => o.value === goal)) goalInput.value = goal;
      this.areaChanged();
    }
    disconnectedCallback() { window.removeEventListener?.('pagehide', this.onPageHide); }
    track(name, data) { window.DodoMetrics?.publish(name, data); }
    areaChanged() {
      const skin = this.form.elements.area.value === 'skin';
      this.querySelector('[data-skin]').hidden = !skin;
      this.querySelector('[data-hair]').hidden = skin;
      this.querySelector('[data-owned-skin]').hidden = !skin;
      this.querySelector('[data-owned-hair]').hidden = skin;
    }
    showStep(step) {
      this.step = Math.max(0, Math.min(2, step));
      this.querySelectorAll('[data-step]').forEach((section, index) => { section.hidden = index !== this.step; });
      this.querySelector('[data-progress]').textContent = `Step ${this.step + 1} of 3`;
      const progress = this.querySelector('[data-progress-bar]');
      if (progress) progress.value = this.step + 1;
      this.querySelector('[data-back]').hidden = this.step === 0;
      this.querySelector('[data-next]').textContent = this.step === 2 ? 'Build my routine' : 'Continue';
      this.querySelector(`[data-step="${this.step}"] input, [data-step="${this.step}"] select`)?.focus();
    }
    profile() {
      const data = new FormData(this.form);
      return {area:data.get('area'),goal:data.get(data.get('area') === 'hair' ? 'hairGoal':'skinGoal'),skinType:data.get('skinType'),sensitive:data.has('sensitive'),fragranceFree:data.has('fragranceFree'),restricted:data.has('restricted') || data.has('under18'),budget:Math.round(Number(data.get('budget')) * 100),owned:data.getAll(data.get('area') === 'hair' ? 'ownedHair':'owned')};
    }
    async refresh(requiredHandles = null) {
      this.catalog = await Promise.all(this.catalog.map(async product => {
        try {
          const live = await jsonRequest(`${this.root}products/${encodeURIComponent(product.handle)}.js`);
          const variant = live.variants.find(v => v.available);
          if (variant && (!Number.isSafeInteger(variant.price) || variant.price < 0)) throw new Error('Invalid product price.');
          return {...product, title:live.title, price:variant?.price ?? product.price, variantId:variant?.id ?? product.variantId, available:Boolean(variant && live.available)};
        } catch (error) {
          if (error.status !== 404 && error.status !== 410 && (requiredHandles === null || requiredHandles.has(product.handle))) throw error;
          return {...product, available:false};
        }
      }));
    }
    reconcileSelection() {
      const fresh = new Map(this.catalog.filter(p => p.available).map(p => [p.handle,p]));
      // Only retain explicit choices, and never substitute a different variant.
      this.selected = new Map([...this.selected].flatMap(([kind, product]) => {
        const current = fresh.get(product.handle);
        return current && current.variantId === product.variantId ? [[kind,current]] : [];
      }));
      this.plan.steps.forEach(step => {
        if (!step.product && !step.alternatives.length) return;
        const choices = [step.product,...step.alternatives].filter(Boolean).map(p => fresh.get(p.handle)).filter(Boolean);
        step.product = this.selected.get(step.kind) || choices[0] || null;
        step.alternatives = choices.filter(p => p.handle !== step.product?.handle);
        if (!step.product && !step.owned) step.message = 'No verified product is currently available for this step. Edit your answers to check again.';
      });
    }
    setPending(pending) {
      this.pending = pending;
      this.querySelectorAll('[data-results] select').forEach(select => { select.disabled = pending; });
      this.querySelector('[data-edit]').disabled = pending;
      const save = this.querySelector('[data-save]');
      if (save) save.disabled = pending;
      this.querySelector('[data-add]').disabled = pending || this.selected.size === 0 || [...this.selected.values()].reduce((sum,p)=>sum+p.price,0) > this.answer.budget;
    }
    money(cents) { return new Intl.NumberFormat('en-AE', {style:'currency',currency:'AED'}).format(cents / 100); }
    routineText() {
      const lines = ['dodo | Your routine', '', 'Product prices at the time this routine was built. Confirm current prices and availability before ordering.', 'Shipping and discounts are confirmed at checkout.', ''];
      for (const step of this.plan.steps) {
        const product = this.selected.get(step.kind);
        lines.push(`${step.label} | ${step.period || ''}`);
        if (product) {
          lines.push(product.title, this.money(product.price), product.usage);
          const url = new URL(product.url, location.origin);
          if (url.origin === location.origin && /\/products\//.test(url.pathname)) lines.push(url.origin + url.pathname);
        } else lines.push('No product selected for this step.');
        lines.push('');
      }
      lines.push(`Selected products: ${this.money([...this.selected.values()].reduce((sum,p)=>sum+p.price,0))}`, '', 'Cosmetic guidance, not a diagnosis. Follow product packaging directions. Compatibility with products you already own has not been checked.');
      return lines.join('\n');
    }
    saveRoutine() {
      if (this.pending || !this.plan) return;
      try {
        const blob = new Blob([this.routineText()], {type: 'text/plain;charset=utf-8'});
        const url = URL.createObjectURL(blob);
        const link = element('a'); link.href = url; link.download = 'dodo-routine.txt';
        document.body.append(link); link.click(); link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      } catch (_) { this.status.textContent = 'Your routine could not be saved. It is still available here.'; }
    }
    async build() {
      if (this.pending) return;
      if (!this.form.elements.budget.reportValidity()) return;
      const button = this.querySelector('[data-next]');
      button.disabled = true;
      this.status.textContent = 'Checking current prices and availability...';
      try {
        await this.refresh();
        this.answer = this.profile();
        this.plan = window.DodoRoutineEngine.buildRoutine(this.answer, this.catalog);
        this.selected = new Map(this.plan.steps.filter(s => s.product).map(s => [s.kind,s.product]));
        this.renderResults();
        this.form.hidden = true;
        this.results.hidden = false;
        this.status.textContent = '';
        this.results.querySelector('h2').focus();
        this.results.querySelector('h2').scrollIntoView({block:'start'});
        this.track('routine_step_completed', {step:3});
        this.track('routine_results_ready', {product_count:this.selected.size});
      } catch (error) { this.status.textContent = 'We could not check the catalogue. Your answers are still here; please try again.'; }
      finally { button.disabled = false; }
    }
    renderResults() {
      const output = this.querySelector('[data-results]');
      const notices = this.querySelector('[data-notices]');
      output.replaceChildren(); notices.replaceChildren();
      this.plan.notices.forEach(text => notices.append(element('p',text,'dr__note')));
      this.plan.steps.forEach((step, index) => {
        const row = element('article',null,'dr__step');
        const heading = element('div',null,'dr__step-heading');
        heading.append(element('h3',`${index + 1}. ${step.label}`),element('span',step.period,'dr__period')); row.append(heading);
        const chosen = this.selected.get(step.kind);
        if (!step.product) row.append(element('p',step.message,'dr__note'));
        else {
          const product = chosen || step.product;
          const block = element('div',null,'dr__product');
          const img = element('img'); img.src = product.image; img.alt = product.title; img.width = 112; img.height = 140; img.loading = 'lazy';
          const copy = element('div'); const link = element('a',product.title); link.href = product.url;
          const title = element('h4'); title.append(link);
          copy.append(title,element('p',this.money(product.price),'dr__price'),element('p',product.reason),element('p',product.usage));
          const label = element('label',null,'dr__field'); label.append(element('span','Your selection'));
          const select = element('select'); select.setAttribute('aria-label',`Product for ${step.label}`);
          const choices = [step.product,...step.alternatives].filter((p,i,list) => list.findIndex(x=>x.handle===p.handle) === i);
          choices.forEach(p => { const name = p.handle.startsWith('langhaar') ? 'Langhaar oil' : (choices.length > 1 ? 'Balea oil' : choiceNames[p.kind]); const option = element('option',`${name} - ${this.money(p.price)}`); option.value = p.handle; select.append(option); });
          const none = element('option','Do not add this step'); none.value = ''; select.append(none); select.value = chosen?.handle || '';
          select.addEventListener('change', () => {
            if (this.pending) { select.value = chosen?.handle || ''; return; }
            const candidate = choices.find(p => p.handle === select.value);
            const other = [...this.selected.entries()].reduce((sum,[kind,p]) => sum + (kind === step.kind ? 0 : p.price),0);
            const activeElsewhere = [...this.selected.entries()].some(([kind,p]) => kind !== step.kind && p.active);
            if (candidate?.active && activeElsewhere) { this.status.textContent = 'This selection would combine active products. Keep your current choice or edit your answers.'; select.value = chosen?.handle || ''; return; }
            if (candidate && other + candidate.price > this.answer.budget) { this.status.textContent = 'This choice would exceed your product budget. Choose a lower-priced option or edit your budget.'; select.value = chosen?.handle || ''; return; }
            if (candidate) this.selected.set(step.kind,candidate); else this.selected.delete(step.kind);
            this.status.textContent = ''; this.renderResults();
            this.querySelectorAll('[data-results] select')[this.plan.steps.slice(0,index).filter(s=>s.product).length]?.focus();
          });
          label.append(select); block.append(img,copy,label); row.append(block);
        }
        output.append(row);
      });
      this.querySelector('[data-total]').textContent = `Selected products: ${this.money([...this.selected.values()].reduce((sum,p)=>sum+p.price,0))}`;
      this.setPending(Boolean(this.pending));
    }
    async addToCart() {
      if (this.pending || this.selected.size === 0) return;
      this.setPending(true);
      this.status.textContent = 'Checking your selection...';
      let submitted = false;
      try {
        const selected = [...this.selected.values()];
        await this.refresh(new Set(selected.map(p => p.handle)));
        const changed = selected.some(p => { const fresh = this.catalog.find(q => q.handle === p.handle); return !fresh?.available || fresh.price !== p.price || fresh.variantId !== p.variantId; });
        this.reconcileSelection();
        this.renderResults();
        if (changed) {
          this.status.textContent = 'Prices or availability changed. Please review the updated selection before adding it.'; return;
        }
        if (!selected.length || selected.reduce((sum,p)=>sum+p.price,0) > this.answer.budget) throw new Error('Please review your selection.');
        submitted = true;
        await jsonRequest(`${this.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:selected.map(p=>({id:p.variantId,quantity:1}))})});
        this.cartAdded = true;
        this.track('routine_cart_added', {product_count:selected.length});
        location.assign(`${this.root}cart`);
      } catch (error) {
        this.status.textContent = submitted ? 'We could not confirm the cart update. Please check your cart before trying again.' : 'We could not verify this selection. Please try again.';
        if (submitted) { const link = element('a',' View cart'); link.href = `${this.root}cart`; this.status.append(link); }
      } finally { this.setPending(false); }
    }
  }
  if (!customElements.get('dodo-routine')) customElements.define('dodo-routine',DodoRoutine);
})();
